import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Navigate, useSearchParams, useNavigate } from 'react-router';
import { useNotification } from '@/context/notification';
import { useRegisterPassword } from '@/data/auth';
import { PasswordForm } from '@/packages/auth/components/password-form';
import {
  type PasswordFormData,
  passwordFormSchema,
} from '@/packages/auth/components/password-form/schema';

export const Register = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useNotification();
  const { mutate: registerPassword, isPending } = useRegisterPassword();

  const token = searchParams.get('token');

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<PasswordFormData>({
    resolver: zodResolver(passwordFormSchema),
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  });

  const submitting = isSubmitting || isPending;

  const onSubmit = async (data: PasswordFormData) => {
    if (!token) return;

    registerPassword(
      { password: data.password, token },
      {
        onSuccess: () => {
          toast({
            content: 'Senha criada com sucesso!',
            type: 'success',
          });
          navigate('/');
        },
        onError: () => {
          toast({
            content:
              'Erro ao criar senha. Tente novamente ou entre em contato com o atendimento.',
            type: 'error',
          });
        },
      }
    );
  };

  if (!token) return <Navigate to="/login" replace />;

  return (
    <PasswordForm
      control={control}
      onSubmit={handleSubmit(onSubmit)}
      submitting={submitting}
    />
  );
};
